import styles from "./index.module.css";
import { useEffect, useState } from "react";
import {
  useDownloadFileMutation,
  useGetFoldersByIdMutation,
  useVerifyAccountMutation,
} from "../../services/api";
import { TiArrowBack } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import {
  DocumentTable2data,
  DocumentTabledata,
  TrancheTabledata,
  folders,
} from "../../utils/data";
import DocumentCard from "./DocumentCard";
import { tracker } from "../../services/mixpanel";

// type IMyDocumentTile =
//   | {
//       folder: {
//         id: string;
//       };
//       type: "FromLearnMore";
//       showSidebar?: boolean;
//       heading: string;
//     }
//   | {
//       folder: {
//         id: string;
//         mimeType: string;
//         name: "Reports" | "Tranches";
//       };
//       type: "Reports" | "Tranches";
//     };

// type IMyDocumentTile =
//   | {
//       folder: {
//         id: string;
//       };
//       type: "FromLearnMore";
//       showSidebar?: boolean;
//       heading: string;
//     }
//   | {
//       folder: {
//         id: string;
//         mimeType: string;
//         name: "Reports" | "Tranches";
//       };
//       type: "Reports" | "Tranches";
//     };

const MyDocumentTile = (props: any) => {
  const { folder } = props;
  const showSidebar = props?.showSidebar == undefined;
  const message = props?.message;
  const length = folders.length;
  const [result, { data, isLoading: loading }] = useVerifyAccountMutation();
  const [downloadFile, { isLoading }] = useDownloadFileMutation();
  const [pinError, setPinError] = useState("");
  const [trancheFolderDoc, setTrancheFolderDoc] = useState(false);
  const [nextPageToken, setNextPageToken] = useState("");
  const [currentFolderId, setCurrentFolderId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const token = localStorage.getItem("token") || "";
  const title = props.title

  // const isDocument = props.type == "documents";
  const isDocument = props.type == "Reports";
  const isLearnMore = props?.type == "FromLearnMore";
  const heading = props?.heading;

  const [documentFolderDetails, setDocumentFolderDetails] = useState<any[]>();
  const [folderIds, setFolderIds] = useState<any[]>([folder.id]);
  const [pageTokens, setPageTokens] = useState<any[]>([]);
  const [documentMutate, { isLoading: documentLoading }] =
    useGetFoldersByIdMutation();

  const getFolders = async (
    folderId?: string,
    nextPageToken?: string,
    direction?: string
  ) => {
    const payload = {
      id: folderId ? folderId : folder.id,
      nextPageToken: nextPageToken || "",
    };
    setCurrentFolderId(payload.id);
    if (direction == "view") {
      setCurrentPage(1);
      setPageTokens([]);
      const newFolderIds = [...folderIds];
      newFolderIds.push(payload.id);
      setFolderIds(newFolderIds);
    }

    const data = (await documentMutate(payload)) as Response<any>;
    if (!data.error) {
      setDocumentFolderDetails(data.data?.data?.message?.files);
      setNextPageToken(data.data?.data?.message?.nextPageToken || "");
      if (data.data?.data?.message?.nextPageToken && direction != "back") {
        const tokens = [...pageTokens];
        tokens.push(data.data?.data?.message?.nextPageToken);
        setPageTokens(tokens);
      }
    }
  };

  useEffect(() => {
    getFolders();
  }, [folder.id]);

  const fetchFile = async (file_id: string) => {
    try {
      if (isLearnMore) {
        tracker.document.documentViewed(file_id, "Overview");
        const previewUrl = `https://drive.google.com/file/d/${file_id}/preview`;
        window.open(previewUrl, "_blank");
        return;
      }
      tracker.document.documentViewed(file_id, "My Documents");
      const response = await fetch(
        `https://investorsportal-797836204.development.catalystserverless.com/server/google_drive_api/file?file_id=${file_id}`
      );
      const data = await response.json();
      window.open(data.link);
    } catch (error) {
      console.error("Error fetching customizations:", error);
    }
  };

  const downloadDocument = async (item: any) => {
    try {
      if (isLearnMore) {
        tracker.document.documentDownload(item.name, "Overview");
        const previewUrl = `https://drive.google.com/uc?id=${item.id}&export=download`;
        window.open(previewUrl, "_blank");
        return;
      }
      tracker.document.documentDownload(item.name, "My Documents");
      const response = await fetch(
        `https://investorsportal-797836204.development.catalystserverless.com/server/google_drive_api/file/download?file_id=${item.id}&file_name=${item.name}`
      );
      if (!response || !response.body) {
        console.log("Something Went Wrong");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = item.name;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("Error downloading pdf file");
    }
  };

  const handleNext = () => {
    // const id = folderData[folderData.length - 1];
    const data = getFolders(
      currentFolderId,
      pageTokens[currentPage - 1],
      "next"
    );
    const newPage = currentPage + 1;
    setCurrentPage(newPage);
  };

  const handleBack = () => {
    const newPage = currentPage - 1;
    setCurrentPage(newPage);
    const data = getFolders(
      currentFolderId,
      pageTokens[currentPage - 1],
      "back"
    );
  };

  const goBack = () => {
    const folderStack = [...folderIds];
    if (folderStack.length != 1) {
      folderStack.pop();
      setFolderIds(folderStack);
    }
    const len = folderStack.length;
    if (len > 0) {
      const data = getFolders(folderStack[len - 1], "", "goBack");
    }
  };
  return (
    <div className={`${styles.content} `}>
      <span
        className="w-[100px] flex bg-slate-100 rounded py-1 mb-1 border border-slate-300  "
        onClick={goBack}
      >
        <TiArrowBack className="text-2xl px-2 w-[40px]" />
        Back
      </span>
      <div className="w-full ">
        {!loading ? (
          <div className="w-full ">
            <h2 className="mb-5 text-2xl">
            {title
              ? title
              : isLearnMore
                ? heading
                : isDocument
                  ? "Presentations, Legal Agreements, and Performance Reports."
                  : "Individual Asset folders organized by Tranche."}
          </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(1, 1fr)",
                gap: "1rem",
              }}
            >
              <div className="flex flex-col lg:flex-row justify-between gap-4 items-stretch">
                <div className="bg-white w-full lg:h-[650px] overflow-y-auto p-3 md:p-5">
                  <div className="flex justify-between mb-2">
                    <div
                      className="w-[70%] items-start m-auto"
                    >
                      <span className="font-semibold">Name</span>
                    </div>
                    <div
                      className="w-[30%] items-start text-center"
                    >
                      <span className="font-semibold">Action</span>
                    </div>
                  </div>

                  <div className="">
                    {documentFolderDetails && documentFolderDetails.length > 0 ? (<DocumentCard
                      documents={documentFolderDetails}
                      fetchFile={fetchFile}
                      getFolders={getFolders}
                      downloadDocument={downloadDocument}
                      documentLoading={documentLoading}
                      loading={loading}
                    />) : documentLoading ? (<div className="flex items-center justify-center h-[60vh] text-gray-500 text-center px-4">
                      <p className="text-base font-medium">
                        Loading documents...
                      </p>
                    </div>) : (<div className="flex items-center justify-center h-[60vh] text-gray-500 text-center px-4">
                      <p className="text-base font-medium">
                        {message || "No files found."}
                      </p>
                    </div>)}
                  </div>

                  <div className="flex p-1 w-full mt-4">
                    {currentPage != 1 && (
                      <button
                        onClick={handleBack}
                        className={`${styles.mydocButton} mr-auto`}
                      >
                        Back
                      </button>
                    )}
                    {nextPageToken != "" && (
                      <button
                        className={`${styles.mydocButton} ml-auto`}
                        onClick={handleNext}
                      >
                        Next
                      </button>
                    )}
                    {/* {isDocument ? (
                      <button className={styles.mydocButton} >Next</button>
                    ) : (
                      <>
                        {trancheFolderDoc ? (
                          <button
                            onClick={() => {
                              setTrancheFolderDoc(false);
                            }}
                            className={styles.mydocButton}
                          >
                            Back
                          </button>
                        ) : (
                          <></>
                        )}
                      </>
                    )} */}
                  </div>
                </div>
                {showSidebar && (
                  <div className="flex flex-col w-full lg:w-[350px] flex-shrink-0 lg:h-[650px] gap-4">
                    <div className="bg-white p-2 lg:h-[317px] overflow-y-auto">
                      <div className="flex items-center justify-center p-3 font-semibold">
                        DOCUMENT KEY
                      </div>
                      <div className="overflow-x-auto">
                        <table className={styles.customtable}>
                          <thead>
                            {isDocument && (
                              <tr>
                                <th className="text-sm p-2">General</th>
                                <th className="text-sm p-2">Definition</th>
                              </tr>
                            )}
                          </thead>
                          {isDocument ? (
                            <tbody className="h-fit ">
                              {DocumentTabledata.map(
                                (item: any, index: any) => (
                                  <tr key={index}>
                                    <td>{item.heading}</td>
                                    <td>{item.detail}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          ) : (
                            <tbody>
                              {TrancheTabledata.map((item: any, index: any) => (
                                <tr key={index}>
                                  <td>{item.heading}</td>
                                  <td>{item.detail}</td>
                                </tr>
                              ))}
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                    {isDocument && (
                      <div className="bg-white p-2 lg:h-[317px] overflow-y-auto">
                        <div className="p-2 overflow-x-auto">
                          <table className={styles.customtable}>
                            <thead>
                              {isDocument ? (
                                <tr>
                                  <th className="text-sm p-2">Bookkeeping</th>
                                  <th className="text-sm p-2">Definition</th>
                                </tr>
                              ) : (
                                <></>
                              )}
                            </thead>

                            <tbody>
                              {DocumentTable2data.map(
                                (item: any, index: any) => (
                                  <tr key={index}>
                                    <td>{item.heading}</td>
                                    <td>{item.detail}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full mb-10 inset-0 flex items-center justify-center">
            <svg
              aria-hidden="true"
              className="w-[60px] h-[60px] text-gray-200 animate-spin dark:text-gray-600 fill-[#55b76c]"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyDocumentTile;
